import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CertificateCardComponent } from './certificate-card/certificate-card.component';
import { CertificateMedalComponent } from './certificate-medal/certificate-medal.component';
import { StudyBundleCertificateCardComponent } from './study-bundle-certificate-card/study-bundle-certificate-card.component';
import { LegacyProgressService } from './legacy-progress-service/legacy-progress.service';
import { TranslatePipeModule } from '../shared/translate.pipe';

@NgModule({
  imports: [CommonModule, TranslatePipeModule],
  declarations: [
    CertificateCardComponent,
    CertificateMedalComponent,
    StudyBundleCertificateCardComponent,
  ],
  exports: [CertificateMedalComponent, StudyBundleCertificateCardComponent],
  providers: [LegacyProgressService],
})
export class CertificatesModule {}



// WEBPACK FOOTER //
// ./ts/app/certificates/certificates.module.ts